import {
  Box,
  SimpleGrid,
  Flex,
  OrderedList,
  ListItem
} from "@chakra-ui/react";
import SectionHeading from "./sectionHeading";
import LineSection from "../lineSection";
import Lang from "../../Lang";

export default function Process() {
  return (
    <Box
      color={"white"}
    >
      <LineSection />

      <SimpleGrid columns={{ base: 1, md: 1, xl: 2 }}>

        {/* left section */}
        <Box>
          <Flex
            justifyContent={"flex-end"}
            alignItems={"center"}
            w={"full"}
          >
            <Box>
              <Box
                w={{ base: "full", md: "md", xl: "xl" }}
                pt={{ base: 10, xl: 20 }}
              >
                <SectionHeading
                  title="Process description"
                />
              </Box>

              <OrderedList
                w={{ base: "full", md: "full", xl: "xl" }}
                pt={{ base: 3, md: 4, xl: 10 }}
                pb={{ base: 20, md: 40 }}
                px={{ base: 4, md: 6 }}
                fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
              >
                <ListItem><Lang text="Fill our formulary." /></ListItem>
                <ListItem><Lang text="An AppOX agent will contact you by mail and ask you for additional information to understand your situation." /></ListItem>
                <ListItem><Lang text="We will mail you the AppOX concept of your application within 30 days, telling you how AppOX could help you." /></ListItem>
              </OrderedList>

            </Box>
            <Box
              w={"100px"}
            ></Box>
          </Flex>
        </Box>

        {/* right section */}
        <Box
          bgImage={"img/jigsaw-hand-puzzle-pieces-gather-together-teamwork-concept-planning-work-as-team.webp"}
          backgroundSize={"cover"}
          backgroundPosition={"top"}
          display={{ base: "none", md: "none", xl: "inline" }}
        >
          <Box className="opacityTop"
            h={"50%"}
          >
            &nbsp;
          </Box>
          <Box className="opacityBottom"
            h={"50%"}
          >
            &nbsp;
          </Box>

        </Box>

      </SimpleGrid>

    </Box>
  );
}